import React, { useState } from "react";
import API from "../config/API";

function CreateExecutor() {
  const user = JSON.parse(localStorage.getItem("user"));

  const [form, setForm] = useState({
    exeFirstName: "",

    exeLastName: "",

    exeEmailId: "",

    exePassword: "",

    exeContactNo: "",

    createdBy: user?.emailId || "",

    creatorId: user?.adminId || user?.userId,

    roles: "APP_EXECUTOR",

    workLocatedPlace: "",

    isActive: true,
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    let err = {};

    // First Name
    if (!form.exeFirstName.trim()) {
      err.exeFirstName = "First name is required";
    } else if (!/^[A-Za-z]+$/.test(form.exeFirstName.trim())) {
      err.exeFirstName = "Only alphabets allowed";
    }

    // Last Name
    if (!form.exeLastName.trim()) {
      err.exeLastName = "Last name is required";
    } else if (!/^[A-Za-z]+$/.test(form.exeLastName.trim())) {
      err.exeLastName = "Only alphabets allowed";
    }

    // Email
    if (!form.exeEmailId.trim()) {
      err.exeEmailId = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.exeEmailId.trim())) {
      err.exeEmailId = "Enter valid email address";
    }

    // Password
    if (!form.exePassword) {
      err.exePassword = "Password is required";
    } else if (form.exePassword.length < 6) {
      err.exePassword = "Minimum 6 characters required";
    }

    // Contact Number
    if (!form.exeContactNo) {
      err.exeContactNo = "Contact number is required";
    } else if (!/^[6-9][0-9]{9}$/.test(form.exeContactNo)) {
      err.exeContactNo = "Enter valid 10 digit mobile number";
    }

    // Role
    if (!form.roles) {
      err.roles = "Role is required";
    }

    // Location
    if (!form.workLocatedPlace.trim()) {
      err.workLocatedPlace = "Work location is required";
    } else if (!/^[A-Za-z0-9 ,.-]+$/.test(form.workLocatedPlace)) {
      err.workLocatedPlace = "Only letters, numbers and basic symbols allowed";
    }

    setErrors(err);

    return Object.keys(err).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Contact number only digits
    if (name === "exeContactNo") {
      const numberValue = value.replace(/\D/g, "").slice(0, 10);

      setForm({
        ...form,
        exeContactNo: numberValue,
      });

      return;
    }

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const response = await fetch(
        `${API.V1}/head/createExecutor`,

        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",

            Authorization: `Bearer ${user?.jwtToken}`,
          },

          body: JSON.stringify(form),
        },
      );

      const res = await response.json();

      if (response.ok) {
        alert(res.message || "Executor Created Successfully");

        setForm({
          exeFirstName: "",

          exeLastName: "",

          exeEmailId: "",

          exePassword: "",

          exeContactNo: "",

          createdBy: user?.emailId || "",

          creatorId: user?.adminId || user?.userId,

          roles: "APP_EXECUTOR",

          workLocatedPlace: "",

          isActive: true,
        });

        setErrors({});
      } else {
        if (response.status === 401) {
          alert("Session Expired. Please login again.");

          localStorage.clear();

          window.location.href = "/";

          return;
        }

        alert(res.message || "Executor creation failed");
      }
    } catch (error) {
      console.error(error);

      alert("Server is not reachable");
    }
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.title}>Create Executor</h2>

      <form onSubmit={handleSubmit}>
        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>First Name</label>

            <input
              style={styles.input}
              name="exeFirstName"
              value={form.exeFirstName}
              onChange={handleChange}
            />

            <span style={styles.error}>{errors.exeFirstName}</span>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Last Name</label>

            <input
              style={styles.input}
              name="exeLastName"
              value={form.exeLastName}
              onChange={handleChange}
            />

            <span style={styles.error}>{errors.exeLastName}</span>
          </div>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Email</label>

          <input
            style={styles.input}
            name="exeEmailId"
            value={form.exeEmailId}
            onChange={handleChange}
          />

          <span style={styles.error}>{errors.exeEmailId}</span>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Password</label>

          <input
            type="password"
            style={styles.input}
            name="exePassword"
            value={form.exePassword}
            onChange={handleChange}
          />

          <span style={styles.error}>{errors.exePassword}</span>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Contact Number</label>

          <input
            style={styles.input}
            name="exeContactNo"
            value={form.exeContactNo}
            onChange={handleChange}
          />

          <span style={styles.error}>{errors.exeContactNo}</span>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Role</label>

          <select
            style={styles.input}
            name="roles"
            value={form.roles}
            onChange={handleChange}
          >
            <option value="APP_EXECUTOR">APP_EXECUTOR</option>
          </select>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Work Location</label>

          <input
            style={styles.input}
            name="workLocatedPlace"
            value={form.workLocatedPlace}
            onChange={handleChange}
          />

          <span style={styles.error}>{errors.workLocatedPlace}</span>
        </div>

        <div style={styles.checkbox}>
          <input
            type="checkbox"
            name="isActive"
            checked={form.isActive}
            onChange={handleChange}
          />

          <label>Active</label>
        </div>

        <button style={styles.button} type="submit">
          Create Executor
        </button>
      </form>
    </div>
  );
}
export default CreateExecutor;

/* ================= CSS STYLE ================= */

const styles = {
  page: {
    width: "100%",
    maxWidth: "650px",
    margin: "40px auto",
    padding: "30px",
    background: "#ffffff",
    borderRadius: "15px",
    boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
    fontFamily: "Arial, sans-serif",
  },

  title: {
    textAlign: "center",
    color: "#1565c0",
    marginBottom: "25px",
    fontSize: "28px",
    fontWeight: "700",
  },

  row: {
    display: "flex",
    gap: "20px",
  },

  field: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    marginBottom: "18px",
  },

  label: {
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "6px",
    color: "#334155",
  },

  input: {
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    fontSize: "15px",
    outline: "none",
    transition: "0.3s",
  },

  error: {
    color: "#dc2626",
    fontSize: "12px",
    marginTop: "5px",
  },

  checkbox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "20px",
    fontWeight: "600",
  },

  button: {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius: "10px",
    background: "linear-gradient(90deg,#1976d2,#1565c0)",
    color: "#fff",
    fontSize: "17px",
    fontWeight: "bold",
    cursor: "pointer",
  },
};
